module.exports = __webpack_public_path__ + "static/media/es.24eff4ba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/es.svg
// module id = 109
// module chunks = 0